// extracted by mini-css-extract-plugin
export default {"day_of_week_table":"style_day_of_week_table__T0j9S","day_td":"style_day_td__MNDg1","td_box":"style_td_box__55m0J","active":"style_active__RXCQx"};